module.exports = __webpack_public_path__ + "static/triangles_right-dbbf66e7a49f5b70e338b893e1ffff29.png";